/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalStaffInvitation_requestDeletePortalStaffInvitation } from '../models/api_portalStaffInvitation_requestDeletePortalStaffInvitation';
import type { api_portalStaffInvitation_requestGetPortalStaffInvitationByToken } from '../models/api_portalStaffInvitation_requestGetPortalStaffInvitationByToken';
import type { api_portalStaffInvitation_requestListPortalStaffInvitations } from '../models/api_portalStaffInvitation_requestListPortalStaffInvitations';
import type { api_portalStaffInvitation_requestResendInvitation } from '../models/api_portalStaffInvitation_requestResendInvitation';
import type { api_portalStaffInvitation_requestSavePortalStaffInvitations } from '../models/api_portalStaffInvitation_requestSavePortalStaffInvitations';
import type { api_portalStaffInvitation_requestSendInvitationRequest } from '../models/api_portalStaffInvitation_requestSendInvitationRequest';
import type { api_portalStaffInvitation_responseDeletePortalStaffInvitation } from '../models/api_portalStaffInvitation_responseDeletePortalStaffInvitation';
import type { api_portalStaffInvitation_responseGetPortalStaffInvitationByToken } from '../models/api_portalStaffInvitation_responseGetPortalStaffInvitationByToken';
import type { api_portalStaffInvitation_responseListPortalStaffInvitations } from '../models/api_portalStaffInvitation_responseListPortalStaffInvitations';
import type { api_portalStaffInvitation_responseResendInvitation } from '../models/api_portalStaffInvitation_responseResendInvitation';
import type { api_portalStaffInvitation_responseSavePortalStaffInvitations } from '../models/api_portalStaffInvitation_responseSavePortalStaffInvitations';
import type { api_portalStaffInvitation_responseSendInvitationRequest } from '../models/api_portalStaffInvitation_responseSendInvitationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalStaffInvitationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Delete PortalStaffInvitation
     * Delete PortalStaffInvitation
     * @returns api_portalStaffInvitation_responseDeletePortalStaffInvitation responseDeletePortalStaffInvitation
     * @throws ApiError
     */
    public postPortalStaffInvitationDelete({
        body,
    }: {
        /**
         * requestDeletePortalStaffInvitation
         */
        body: api_portalStaffInvitation_requestDeletePortalStaffInvitation,
    }): CancelablePromise<api_portalStaffInvitation_responseDeletePortalStaffInvitation> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalStaffInvitation By Token
     * Get PortalStaffInvitation By Token
     * @returns api_portalStaffInvitation_responseGetPortalStaffInvitationByToken responseGetPortalStaffInvitationByToken
     * @throws ApiError
     */
    public postPortalStaffInvitationGetByToken({
        body,
    }: {
        /**
         * requestGetPortalStaffInvitationByToken
         */
        body: api_portalStaffInvitation_requestGetPortalStaffInvitationByToken,
    }): CancelablePromise<api_portalStaffInvitation_responseGetPortalStaffInvitationByToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/get_by_token',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List PortalStaffInvitation
     * List PortalStaffInvitation
     * @returns api_portalStaffInvitation_responseListPortalStaffInvitations responseListPortalStaffInvitations
     * @throws ApiError
     */
    public postPortalStaffInvitationList({
        body,
    }: {
        /**
         * requestListPortalStaffInvitations
         */
        body: api_portalStaffInvitation_requestListPortalStaffInvitations,
    }): CancelablePromise<api_portalStaffInvitation_responseListPortalStaffInvitations> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resend staff invitation
     * 掲載スタッフの招待を再送する
     * @returns api_portalStaffInvitation_responseResendInvitation responseResendInvitation
     * @throws ApiError
     */
    public postPortalStaffInvitationResend({
        body,
    }: {
        /**
         * requestResendInvitation
         */
        body: api_portalStaffInvitation_requestResendInvitation,
    }): CancelablePromise<api_portalStaffInvitation_responseResendInvitation> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/resend',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalStaffInvitations
     * Save PortalStaffInvitations（複数一括登録）
     * @returns api_portalStaffInvitation_responseSavePortalStaffInvitations responseSavePortalStaffInvitations
     * @throws ApiError
     */
    public postPortalStaffInvitationSave({
        body,
    }: {
        /**
         * requestSavePortalStaffInvitations
         */
        body: api_portalStaffInvitation_requestSavePortalStaffInvitations,
    }): CancelablePromise<api_portalStaffInvitation_responseSavePortalStaffInvitations> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send Invitation Request
     * iBowIDが指定された場合は掲載スタッフの取り込み依頼、指定されない場合は掲載スタッフの招待依頼を送信する。
     * @returns api_portalStaffInvitation_responseSendInvitationRequest responseSendInvitationRequest
     * @throws ApiError
     */
    public postPortalStaffInvitationSendInvitationRequest({
        body,
    }: {
        /**
         * requestSendInvitationRequest
         */
        body: api_portalStaffInvitation_requestSendInvitationRequest,
    }): CancelablePromise<api_portalStaffInvitation_responseSendInvitationRequest> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_invitation/send_invitation_request',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
